import React, { useRef, useState } from "react";
import Lottie from "lottie-react";
import Slider from "react-slick";
import hiredAnimation from "../../lotties/hired_15332421.json";
import startupAnimation from "../../lotties/startup_8722705.json";
import developmentAnimation from "../../lotties/development_18999310.json";
import locationAnimation from "../../lotties/location_17675753.json";
import { motion } from "framer-motion";
import { FaTelegram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const RoadMap = () => {
  const roadmapData = [
    {
      quarter: "Q1 2025",
      title: "PRIVATE SALE & PRESALE",
      description: [
        "Launch private and presale rounds for early supporters.",
        "Distribute 10% of total supply in presale.",
        "Onboard first wave of auditors and security experts."
      ],
      position: "right",
      icon: hiredAnimation
    },
    {
      quarter: "Q2 2025",
      title: "PUBLIC SALE & PLATFORM LAUNCH",
      description: [
        "Token public sale begins.",
        "Launch core platform features.",
        "Deploy audit marketplace and bug bounty system."
      ],
      position: "left",
      icon: startupAnimation
    },
    {
      quarter: "Q3 2025",
      title: "GROWTH & EDUCATION",
      description: [
        "Focus on community growth initiatives.",
        "Launch Ciphegis Academy.",
        "Train new security researchers."
      ],
      position: "right",
      icon: developmentAnimation
    },
    {
      quarter: "Q4 2025",
      title: "BEYOND - EXPANSION & INNOVATION",
      description: [
        "Expand platform features.",
        "Partner with major protocols.",
        "Continue blockchain security innovation."
      ],
      position: "left",
      icon: locationAnimation
    }
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: '0px',
  };
  const socialLinks = [
    {
      name: 'Telegram',
      url: 'https://t.me/ciphegis2050',
      icon: FaTelegram
    },
    {
      name: 'Twitter',
      url: 'https://x.com/ciphegis',
      icon: FaXTwitter
    }
  ];
  const sliderRef = useRef(null);

  return (
    <section className="relative pt-[200px] pb-[200px] bg-black" id="Roadmap">
      <div className="container mx-auto px-4 relative">
        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="text-center mb-40"
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">ROADMAP</h2>
        </motion.div>

        {/* Timeline */}
        <div className="relative hidden lg:block">
          {/* Triangle at the top */}
          <div className="absolute left-1/2 -translate-x-1/2 -top-[115px] w-0 h-0 
            border-l-[12px] border-r-[12px] border-b-0 border-t-[16px] 
            border-solid border-[#22C8BF] border-l-transparent border-r-transparent" />
          <div className="absolute left-1/2 -bottom-[120px]  transform -translate-x-1/2 h-[115%] w-[2px] bg-[#22C8BF]" />
          <div className="absolute -bottom-[120px] w-4 h-4 left-1/2 transform -translate-x-1/2 bg-[#22C8BF] rounded-full" />
          <div className="relative z-10">
            {roadmapData.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 100 }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                  transition: {
                    duration: 1,
                    delay: index * 0.3,
                    ease: [0.21, 0.47, 0.32, 0.98]
                  }
                }}
                viewport={{ once: true, margin: "-100px" }}
                className="flex items-start mb-48 last:mb-0"
              >
                <div className={`w-full px-[250px] flex ${item.position === 'left' ? 'justify-start' : 'justify-end'} relative`}>
                  <div className={`lg:w-[680px] relative w-full ${item.position === 'left' ? 'ml-0' : 'mr-0'} 
                    bg-white
                    p-6 rounded-r-3xl rounded-b-3xl border`}
                  >
                    <div className="flex items-start gap-4">
                      <div className="flex">
                        <div className="w-[180px] h-[180px]">
                          <Lottie
                            animationData={item.icon}
                            loop={true}
                            autoplay={true}
                            style={{ width: '100%', height: '100%' }}
                          />
                        </div>
                        <div className="flex flex-col justify-center items-start">
                          <h3 className="text-black text-lg font-bold mb-4 max-w-[220px]">{item.title}</h3>
                          {Array.isArray(item.description) ? (
                            <ul className="space-y-2">
                              {item.description.map((bullet, idx) => (
                                <li key={idx} className="flex items-center gap-2">
                                  <span className="text-black text-sm">•</span>
                                  <p className="text-black text-base leading-relaxed">{bullet}</p>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <p className="text-black text-sm leading-relaxed">{item.description}</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={`absolute left-0 -top-14 text-[#22C8BF] text-[34px] font-medium`}>
                      {item.quarter}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.2 }}
          viewport={{ once: true }}
          className="w-full h-full flex-col items-center  justify-center mt-[140px]  hidden lg:flex"
        >
          <div className="flex w-20 h-20 items-center">
            <img
              src="/static/images/Logo.svg"
              className="w-20 h-20"
              alt="taptool"
            />
          </div>
          <div className="text-center mt-12">
            <div className="flex items-center justify-center gap-2 w-full mb-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-1 hover:bg-[#22C8BF]/10 rounded-lg transition-all duration-300"
                >
                  <social.icon
                    className="w-6 h-6 text-white hover:text-[#22C8BF] hover:scale-110 transition-all duration-300"
                  />
                </a>
              ))}
            </div>
            <p className="text-white text-sm opacity-80">© ALL RIGHTS RESERVED 2025</p>
          </div>
        </motion.div>
        {/* Mobile Timeline Carousel */}
        <div className="lg:hidden relative ">
          <Slider ref={sliderRef} {...settings}>
            {roadmapData.map((item, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: idx * 0.2 }}
                viewport={{ once: true }}
                className="px-4"
              >
                <div className="relative">
                  <span className="text-[#22C8BF] text-xl font-medium mb-4 block">{item.quarter}</span>
                  <div className="bg-white p-6 rounded-xl border">
                    <div className="flex flex-col gap-4">
                      <div className="w-[120px] h-[120px] mx-auto">
                        <Lottie
                          animationData={item.icon}
                          loop={true}
                          autoplay={true}
                          style={{ width: '100%', height: '100%' }}
                        />
                      </div>
                      <div>
                        <h3 className="text-black text-lg font-bold mb-4">{item.title}</h3>
                        {Array.isArray(item.description) ? (
                          <ul className="space-y-2">
                            {item.description.map((bullet, idx) => (
                              <li key={idx} className="flex items-start gap-2">
                                <span className="text-black text-sm mt-1">•</span>
                                <p className="text-black text-base leading-relaxed">{bullet}</p>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-black text-sm leading-relaxed">{item.description}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </Slider>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
            viewport={{ once: true }}
            className="relative pt-8 flex justify-center"
          >
            <div className="w-16 h-16">
              <img
                src="/static/images/Logo.svg"
                className="w-full h-full"
                alt="taptool"
              />
            </div>
          </motion.div>
          <div className="text-center mt-12">
            <div className="flex items-center justify-center gap-2 w-full mb-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-1 hover:bg-[#22C8BF]/10 rounded-lg transition-all duration-300"
                >
                  <social.icon
                    className="w-6 h-6 text-white hover:text-[#22C8BF] hover:scale-110 transition-all duration-300"
                  />
                </a>
              ))}
            </div>
            <p className="text-white text-sm opacity-80">© ALL RIGHTS RESERVED 2025</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoadMap; 